// extracted by mini-css-extract-plugin
export default {"App":"App_App__LTxCz","connectionBox":"App_connectionBox__OMncf","spinAround":"App_spinAround__SdDnq"};